import { attr, belongsTo, hasMany } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import RecurringInvite from 'garaje/models/recurring-invite';

// Splits one occurrence out of a recurring series. The API inherits series/token/creator from
// previousRecurringInvite and builds the single-occurrence rule, so no recurringRule is sent.
export default class RecurringInviteOneOff extends RecurringInvite {
  @belongsTo('recurring-invite', { async: true, inverse: null }) declare previousRecurringInvite:
    | AsyncBelongsTo<RecurringInvite>
    | RecurringInvite;
  // The occurrence's original date (YYYY-MM-DD); the API pins the new occurrence to this day.
  @attr('string') declare splitOccurrenceDate: string;

  // Override the inherited inverse: a write-only split create doesn't wire the reverse side, and
  // visitor-document.recurringInvites is typed to recurring-invite (the subclass can't satisfy it).
  @hasMany('visitor-document', { async: false, inverse: null })
  declare visitorDocuments: RecurringInvite['visitorDocuments'];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'recurring-invite-one-off': RecurringInviteOneOff;
  }
}
